import { render } from "./Notification1.vue?vue&type=template&id=34fa8b04"
import script from "./Notification1.vue?vue&type=script&lang=js"
export * from "./Notification1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__